import { mainCls as detailsCls } from '../../style';

export const mainCls =  `${detailsCls}__feats`;

export default {
  [`${mainCls}__text`]: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: '24px',
    '&.first': {
      alignItems: 'baseline',
    }
  },
  [`${mainCls}__text--auction`]: {
    display: 'inline-block',
    marginBottom: 1,
    padding: '2px 4px',
    height: 19,
    lineHeight: '15px',
    color: '#663E11',
    borderRadius: 4,
    background: '#FFEBD4',
    alignSelf: 'center',
  },
  [`${mainCls}--price`]: {
    fontSize: 20,    
  },
  [`${mainCls}__items`]: {
    gap: '0 16px',
    flexWrap: 'wrap',
    '&.iosLth12': {
      '& .csaSrpcard__det__feats__item': {
        paddingRight: 16,
      }
    }
  },
  [`${mainCls}__item`]: {
    whiteSpace: 'nowrap',
  },
  [`${mainCls}__item--ec`]: {
    marginTop: -3,
    marginLeft: -3,
  },
  [`${mainCls}__item--cp`]: {
    marginTop: -3,
  },
};
